import { useSyncExternalStore } from 'react';

const listeners = new Set<Function>();

const subscribe = (callback: Function) => {
  listeners.add(callback);
  return () => listeners.delete(callback);
};

const singletonSelectedApPayeeIsBank: Map<string, boolean | undefined> =
  new Map<string, boolean | undefined>(undefined);
const prevSelectedApPayeeIsBank: Map<string, boolean | undefined> = new Map<
  string,
  boolean | undefined
>(undefined);

const getSnapshotApPayeeIsBank = () =>
  singletonSelectedApPayeeIsBank.has(location.href)
    ? singletonSelectedApPayeeIsBank.get(location.href)
    : undefined;
const getSnapshotPreviousApPayeeIsBank = () =>
  prevSelectedApPayeeIsBank.has(location.href)
    ? prevSelectedApPayeeIsBank.get(location.href)
    : undefined;

export const useSelectedApPayeeIsBankTransfer = () => {
  return useSyncExternalStore(subscribe, getSnapshotApPayeeIsBank);
};

export const usePrevApPayeeIsBankTransfer = () => {
  return useSyncExternalStore(subscribe, getSnapshotPreviousApPayeeIsBank);
};

export const updateSelectedApPayeeIsBank = (isBank: boolean | undefined) => {
  const key = location.href;

  const current = singletonSelectedApPayeeIsBank.get(key);
  prevSelectedApPayeeIsBank.set(key, current);

  singletonSelectedApPayeeIsBank.set(key, isBank);

  listeners.forEach((listener) => listener());
};
